/**
 * @desc 查看环保监测图标曲线
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<defs.EnvironmentalMonitoringCurveResponse>> {
  return defHttp.post({
    url: '/web/monitoring/queryEpMonitorCurve',
    data,
  });
}

export function mock(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<defs.EnvironmentalMonitoringCurveResponse>> {
  return defHttp.post({
    url: '/mock/web/monitoring/queryEpMonitorCurve',
    data,
  });
}
